import React from "react";
import { Helmet } from "react-helmet-async";
import PageWrapper from "../../Components/Layout/PageWrapper/PageWrapper";
import NavigationBar from "../../Components/HighLevelComponents/NavigationBar/NavigationBar";

const TermsOfService: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Yippity</title>
        <meta
          name="description"
          content="Yippity's Terms of Service - Learn about the rules and guidelines for using our platform."
        />
      </Helmet>

      <PageWrapper>
        <NavigationBar />
        <div className="container mx-auto px-4 py-16 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">
            Terms of Service
          </h1>
          <div className="prose prose-lg">
            <p className="text-gray-600 mb-6">
              Last updated: {new Date().toLocaleDateString()}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              1. Agreement to Terms
            </h2>
            <p className="text-gray-600 mb-4">
              By accessing or using Yippity, you agree to be bound by these
              Terms of Service. If you disagree with any part of the terms, then
              you may not access the service.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              2. Use License
            </h2>
            <p className="text-gray-600 mb-4">
              Permission is granted to temporarily use Yippity for personal,
              non-commercial transitory viewing only. This is the grant of a
              license, not a transfer of title, and under this license you may
              not:
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose</li>
              <li>
                Attempt to reverse engineer any software contained on Yippity
              </li>
              <li>Remove any copyright or other proprietary notations</li>
              <li>Transfer the materials to another person</li>
            </ul>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              3. User Accounts
            </h2>
            <p className="text-gray-600 mb-4">
              When you create an account with us, you must provide accurate,
              complete, and current information. Failure to do so constitutes a
              breach of the Terms, which may result in immediate termination of
              your account.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              4. Subscription and Payments
            </h2>
            <p className="text-gray-600 mb-4">
              Some parts of the Service are billed on a subscription basis. You
              will be billed in advance on a recurring and periodic basis,
              depending on the type of subscription plan you select.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              5. Content
            </h2>
            <p className="text-gray-600 mb-4">
              Our Service allows you to post, link, store, share and otherwise
              make available certain information, text, graphics, videos, or
              other material. You are responsible for the content that you post
              on or through the Service.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              6. Intellectual Property
            </h2>
            <p className="text-gray-600 mb-4">
              The Service and its original content, features, and functionality
              are and will remain the exclusive property of Yippity and its
              licensors. The Service is protected by copyright, trademark, and
              other laws of both the United States and foreign countries.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              7. Limitation of Liability
            </h2>
            <p className="text-gray-600 mb-4">
              In no event shall Yippity, nor its directors, employees, partners,
              agents, suppliers, or affiliates, be liable for any indirect,
              incidental, special, consequential or punitive damages, including
              without limitation, loss of profits, data, use, goodwill, or other
              intangible losses.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              8. Changes to Terms
            </h2>
            <p className="text-gray-600 mb-4">
              We reserve the right to modify or replace these Terms at any time.
              If a revision is material, we will provide at least 30 days'
              notice prior to any new terms taking effect.
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              9. Contact Us
            </h2>
            <p className="text-gray-600">
              If you have any questions about these Terms, please contact us at:
            </p>
            <p className="text-gray-600">Email: support@yippity.io</p>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default TermsOfService;
